module.exports = __webpack_public_path__ + "static/img/user.c8d952d2.png";